// Generated from api/openapi/operations.yaml by make docs. Do not edit.
import { z } from "zod";

export const pulseMetricSchema = z.object({
  "measured": z.boolean(),
  "percent": z.number().int().nullable(),
  "numerator": z.number().int().nullable(),
  "denominator": z.number().int().nullable(),
  "note": z.string()
});

export const tenantKpisSchema = z.object({
  "identities_total": z.number().int().min(0),
  "people_total": z.number().int().min(0),
  "non_human_total": z.number().int().min(0),
  "non_humans_no_owner": z.number().int().min(0),
  "phishing_resistant": pulseMetricSchema,
  "non_human_protection": pulseMetricSchema,
  "users_total": z.number().int().min(0),
  "users_active": z.number().int().min(0),
  "passkeys_total": z.number().int().min(0),
  "passkey_coverage_percent": z.number().int().min(0).max(100),
  "sign_ins_24h": z.number().int().min(0),
  "failed_sign_ins_24h": z.number().int().min(0),
  "step_up_challenges_24h": z.number().int().min(0),
  "tenant_admins_active": z.number().int().min(0),
  "tenant_operators_active": z.number().int().min(0),
  "org_admins_active": z.number().int().min(0),
  "org_operators_active": z.number().int().min(0),
  "applications_total": z.number().int().min(0),
  "organizations_total": z.number().int().min(0),
  "recovery_requests_open": z.number().int().min(0),
  "webhooks_failing": z.number().int().min(0)
});

export const tenantOverviewAlertSchema = z.object({
  "id": z.string(),
  "kind": z.enum(["tenant_no_passkeys", "webhook_failing", "policy_block_spike", "admin_invite_stale", "api_key_expiring"]),
  "severity": z.enum(["info", "warning", "danger"]),
  "title": z.string(),
  "description": z.string(),
  "href": z.string().nullable(),
  "tenant_slug": z.string().nullable(),
  "created_at": z.string().datetime({ offset: true })
});

export const tenantSignInTrendPointSchema = z.object({
  "date": z.string(),
  "success": z.number().int().min(0),
  "failure": z.number().int().min(0)
});

export const tenantOverviewSchema = z.object({
  "tenant_id": z.string().uuid(),
  "tenant_slug": z.string(),
  "tenant_name": z.string(),
  "primary_domain": z.string().nullable(),
  "created_at": z.string().datetime({ offset: true }),
  "kpis": tenantKpisSchema,
  "alerts": z.array(tenantOverviewAlertSchema),
  "signin_trend": z.array(tenantSignInTrendPointSchema)
});
